import { twMerge } from 'tailwind-merge';

import { Text } from '@/_components';

import { InvoiceEmailRecipientItem } from './invoice-email-recipient-item';

import type { InvoiceEmailRecipient } from '../get-invoice-email-recipients';

type InvoiceEmailRecipientsListProps = {
  recipients: InvoiceEmailRecipient[];
  className?: string;
  /** Hide section heading (e.g. nested inside tooltip table cell). */
  showHeading?: boolean;
  compact?: boolean;
  emptyMessage?: string;
};

const defaultEmptyMessage = 'No billing or notification contacts are available to email.';

export function InvoiceEmailRecipientsList({
  recipients,
  className,
  showHeading = true,
  compact = false,
  emptyMessage = defaultEmptyMessage,
}: InvoiceEmailRecipientsListProps) {
  if (recipients.length === 0) {
    return (
      <div className={twMerge('col-span-12', className)}>
        <Text className={twMerge('text-c-card-muted', compact ? 'text-xs' : 'text-sm')}>{emptyMessage}</Text>
      </div>
    );
  }

  return (
    <div className={twMerge('col-span-12 space-y-2', className)}>
      {showHeading ? (
        <Text className={twMerge('text-c-card-foreground font-semibold', compact ? 'text-xs' : 'text-sm')}>
          Recipients ({recipients.length})
        </Text>
      ) : null}
      <ul
        className={twMerge(
          compact ? 'space-y-2' : 'space-y-3',
          recipients.length > 3 && (compact ? 'max-h-28' : 'max-h-36'),
          recipients.length > 3 && 'overflow-y-auto pr-1'
        )}
      >
        {recipients.map((recipient) => (
          <InvoiceEmailRecipientItem
            key={`${recipient.id}-${recipient.email ?? ''}`}
            recipient={recipient}
            compact={compact}
          />
        ))}
      </ul>
    </div>
  );
}
